import angular from "angular";
import template from "./admin-students-index.html";
import AdminStudentsIndexController from "./admin-students-index.controller";
import ResetServiceAreaModalController from "./reset-service-area-modal/reset-service-area-modal.controller";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.students.index", {
    url: "/index",
    controller: AdminStudentsIndexController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.students.index", [])
  .config(config)
  .controller("AdminStudentsIndexController", AdminStudentsIndexController)
  .controller(
    "ResetServiceAreaModalController",
    ResetServiceAreaModalController,
  );
